import { render, staticRenderFns } from "./TireInspectionComponent.vue?vue&type=template&id=a17c9bd8&"
import script from "./TireInspectionComponent.vue?vue&type=script&lang=js&"
export * from "./TireInspectionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports